/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'structure': {
    viewBox: '0 0 24 24',
    data: '<path d="M12.021,18.741,3.028,13.965l-.49.923,9.487,5.039,9.912-5.36-.5-.92Zm9.916-7.46-.5-.919-9.419,5.093L3.028,10.68l-.49.923,9.487,5.038ZM20.889,8.518l-8.906-4.49-8.9,4.49,8.9,4.6ZM11.983,5.2,18.59,8.53l-6.607,3.411L5.382,8.53Z"/>'
  }
})
